import { optionalDevtools } from 'zustand-utils';
import { devtools as _devtools } from 'zustand/middleware';

import { isDev } from '@/utils_cp/env';

export const createDevtools =
  (name: string, enabledByDefault = isDev): typeof _devtools =>
  (initializer) => {
    let showDevtools = enabledByDefault;

    // check url to show devtools in production or override in development
    if (typeof window !== 'undefined') {
      const url = new URL(window.location.href);
      const debug = url.searchParams.get('debug');
      if (debug?.includes(name)) {
        showDevtools = true;
      }
      // Allow disabling in development with ?debug=false
      if (debug === 'false') {
        showDevtools = false;
      }
    }

    return optionalDevtools(showDevtools)(initializer, {
      name: `SilverTigerChat_${name}` + (isDev ? '_DEV' : ''),
    });
  };
